import { BuilderProductGridInlineBanner } from "@faire/deprecated-retailer-visitor-shared/components/SignUpProductGridBanner/BuilderProductGridInlineBanner";
import { useIsLoggedInRetailer } from "@faire/deprecated-retailer-visitor-shared/lib/isLoggedInRetailer";
import { useIsSemDiscoverPage } from "@faire/deprecated-retailer-visitor-shared/lib/useIsSemDiscoverPage";
import { useSettingEnableDiscoverCategoryCTABanners } from "@faire/deprecated-retailer-visitor-shared/settings/useSettingEnableDiscoverCategoryCTABanners";
import { useIsLoggedOutDiscoverPage } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useIsLoggedOutDiscoverPage";
import { useDiscoverPageShouldShowTopProducts } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/util/useDiscoverPageShouldShowTopProducts";
import { IThreeVariantXP } from "@faire/web-api--source/indigofair/settings/IThreeVariantXP";
import { getSpacing } from "@faire/web/slate/spacing";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import { ResponsiveValues } from "@faire/web/slate/Theme/ResponsiveValues";
import { useResponsiveValue } from "@faire/web/ui/hooks/useResponsiveValue";
import { useMemo } from "react";
import styled from "styled-components";

const FIRST_BANNER_ROW = 3;
const BANNER_REPEAT_INTERVAL = 5;
const MAX_BANNER_ROWS = 3;

export const InlineBannerSection: React.FC<{
  itemsPerRowResponsive: ResponsiveValues<number>;
  productLength: number;
}> = ({ itemsPerRowResponsive, productLength }) => {
  const itemsPerRow = useResponsiveValue(itemsPerRowResponsive);
  const discoverCategoryCTABannersVariant =
    useSettingEnableDiscoverCategoryCTABanners();
  const settingShouldRepeatInlineBanner =
    discoverCategoryCTABannersVariant === IThreeVariantXP.Bucket.VARIANT_3;

  const isLoggedIn = useIsLoggedInRetailer();
  const isDiscoverPageShouldShowTopProducts =
    useDiscoverPageShouldShowTopProducts();
  const isLoggedOutDiscoverPage = useIsLoggedOutDiscoverPage();
  const isSemDiscoverPage = useIsSemDiscoverPage();

  const shouldShowRepeatInlineBanner =
    isLoggedOutDiscoverPage &&
    settingShouldRepeatInlineBanner &&
    !isSemDiscoverPage;

  const shouldShowInlineBanner =
    !isLoggedIn &&
    (!isDiscoverPageShouldShowTopProducts || shouldShowRepeatInlineBanner);

  const multiSignUpProductGridBannerRows = useMemo(() => {
    let totalRows = Math.ceil(productLength / itemsPerRow);

    const bannerRows: number[] = [];
    let row = FIRST_BANNER_ROW;
    while (row <= totalRows + 1) {
      bannerRows.push(row);
      totalRows += 1;
      row += BANNER_REPEAT_INTERVAL;
    }

    return bannerRows.slice(
      0,
      shouldShowRepeatInlineBanner ? MAX_BANNER_ROWS : 1
    );
  }, [settingShouldRepeatInlineBanner, productLength, itemsPerRow]);

  if (!shouldShowInlineBanner) {
    return null;
  }

  return (
    <>
      {multiSignUpProductGridBannerRows.map((row, index) => (
        <BannerWrapper key={index} $gridRow={row}>
          <BuilderProductGridInlineBanner />
        </BannerWrapper>
      ))}
    </>
  );
};

const BannerWrapper = styled.div<{
  $gridRow: number;
}>`
  width: 100%;
  padding: 8px 4px;

  ${responsiveMediaQueries.tabletAndAbove} {
    padding: ${getSpacing("1x", "1x", 0, "1x")};
  }

  grid-column: start/end;
  grid-row: ${({ $gridRow }) => $gridRow} / span 1;
`;
